import cx from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import { useHeaderContext } from '../../context/header-context';

type MobileBottomSectionProps = PropsWithChildren<{
  className?: string;
  leadingChild?: ReactNode;
  leadingChildClassname?: string;
  trailingChild?: ReactNode;
  trailingChildClassname?: string;
}>;

export const MobileBottomSection = ({
  className,
  children,
  leadingChild,
  leadingChildClassname,
  trailingChild,
  trailingChildClassname,
}: MobileBottomSectionProps) => {
  const {
    navigation: { languageSelectorOptions },
    user: { user },
  } = useHeaderContext();

  return (
    <div
      className={cx('flex content-center items-center p-2 md:px-8 lg:px-10', className, {
        'sm:h-16': !!languageSelectorOptions,
        'h-min py-1': !languageSelectorOptions,
        'px-2': !languageSelectorOptions,
      })}
      data-testid="header-mobile-bottom-section"
    >
      {leadingChild != null && <div className={leadingChildClassname}>{leadingChild}</div>}

      {trailingChild != null && (
        <div
          className={cx(
            'ms-auto flex flex-col items-center gap-x-2 sm:flex-row',
            trailingChildClassname
          )}
        >
          <div className={cx('ms-auto flex gap-x-2', user ? 'items-center' : 'items-end')}>
            {trailingChild}
          </div>
        </div>
      )}
      {children}
    </div>
  );
};
